import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import Notifications from 'vue-notification'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueJalaliMoment from 'vue-jalali-moment'
import Clipboard from 'v-clipboard'
import UUID from "vue-uuid"
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.use(Notifications)
Vue.use(VueAxios, axios)
axios.defaults.baseURL = 'https://idehgate.ir/rest/'
axios.interceptors.request.use(function (config) {
  config.headers.Authorization =  store.state.token;
  return config;
});
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if(store.state.token == null){
            next({
                path: '/signin',
                query: { redirect: to.fullPath }
            })
        } else if(new Date() > new Date(store.state.expires)){
            next({
                path: '/signin',
                query: { redirect: to.fullPath }
            })
        }
        else{
            next();
        }
    } else {
        next()
    }
})
Vue.use(VueJalaliMoment)
Vue.use(Clipboard)
Vue.use(UUID);
Vue.use(VuePersianDatetimePicker, {name: 'date-picker', props: { editable: true }});
Vue.component('apexchart', VueApexCharts)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
